import { useEffect, useState } from 'react';
import { liveIvrEnvironment, readLiveIvrCapability } from '../services/liveIvrEnvironment';
import { captureSession, isSessionCurrent } from '../utils/authSession';

export default function useLiveIvrCapability({ open, actorId, sessionVersion, target }) {
  const policy = liveIvrEnvironment();
  const binding = `${actorId}:${sessionVersion}:${target}:${open}`;
  const [result, setResult] = useState({ binding: '', status: 'loading' });
  useEffect(() => {
    if (!open || !policy.required) return;
    if (!policy.allowed) {
      setResult({ binding, status: 'unavailable' });
      return;
    }
    const controller = new AbortController();
    const sessionBinding = captureSession();
    let active = true;
    setResult({ binding, status: 'loading' });
    readLiveIvrCapability({ signal: controller.signal, sessionBinding })
      .then(() => {
        if (active && !controller.signal.aborted && isSessionCurrent(sessionBinding))
          setResult({ binding, status: 'ready', sessionBinding });
      })
      .catch(() => {
        if (active && !controller.signal.aborted && isSessionCurrent(sessionBinding))
          setResult({ binding, status: 'unavailable' });
      });
    return () => {
      active = false;
      controller.abort();
    };
  }, [open, policy.required, policy.allowed, binding]);
  const status = result.binding === binding ? result.status : 'loading';
  const isCurrent = () =>
    policy.allowed && status === 'ready' && isSessionCurrent(result.sessionBinding);
  return { required: policy.required, ready: isCurrent(), status, isCurrent };
}
